export enum StatusEnum {
    AWAITING='AWAITING',
    EXECUTING='EXECUTING',
    COMPLETED='COMPLETED',
    ERROR='ERROR'
}
